import { Schema } from '@core/data/dto/schema';

export const DeliveryOrderLocationSchema = {
    id: Schema.String,
    name: Schema.String,
    lat: Schema.Number,
    lng: Schema.Number,
    latitude: Schema.Number,
    longitude: Schema.Number,
};
